module.exports = __webpack_public_path__ + "static/img/dilemma01.3aad546.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dilemma01.png
// module id = 6J0c
// module chunks = 34